import Axios from "axios";
import ManufacturerDTO from "../DTO/Manufacturer";
import TransmitterDeviceDTO from "../DTO/TransmitterDevice";
import TargetFirmwareVersionsResponse from "../DTO/TargetFirmwareVersionsResponse";
import CampaignDTO from "../DTO/Campaign";
import BaseService from "./BaseService";

export default class MainService extends BaseService  {
  constructor(keycloakToken, currentScope) {
    super(keycloakToken, currentScope);
  }

  async getEquipmentDetails(deviceId, headers = null) {
    return this.get(this.GetUri() + "devices/parameters/" + deviceId, headers);
  }

  async GetEquipmentByReference(reference) {
    return this.get(this.GetUri() + `devices?$filter=(ExternalId eq '${reference}')`);
  }

  async getMessageErrorCode(culture) {
    return this.get(this.GetUri() + `DeviceImports/Translations?cultureName=${culture}`);
  }

  async getParametersSources(equipmentId, equipmentType, headers = null) {
    return this.get(this.GetUri() + "devices/parameters/sources/" + equipmentId + "/" + equipmentType, headers);
  }

  async getFilterParameters(headers = null) {
    return this.get(this.GetUri() + `devices/GetFilterParam`, headers);
  }


  async getDataModel(equipmentId, headers = null) {
    return this.get(this.GetUri() + "devices/dataModel/" + equipmentId, headers);
  }

  async getDistinct(controller, field) {
    return this.get(this.GetUri() + controller + `?$apply=groupby((${field}))`);
  }

  async GetdeviceImportReportByExternalId(deviceImportId, reference) {
    return this.get(this.GetUriApi() + `DeviceImportReports?deviceImportId=${deviceImportId}&$filter=(ExternalId eq '${reference}')`);
  }

  async getdevices() {
    return (await this.get(this.GetUriApi() + "devices")).value;
  }

  async getdeviceDetailsByExternalId(externalId) {
    return this.get(this.GetUri() + `devices/details/${externalId}`);
  }

  async getFileProcessing(deviceImportId) {
    return (await this.get(this.GetUriApi() + `DeviceImports?$format=json&$count=true&$filter=(Id eq ${deviceImportId})`)).value;
  }

  async getdevicesByExternalId(data) {
    return await this.getAsync(this.GetUri() + "Devices/ByExternalId?externalId=" + data);
  }
  
  async getdevicesById(Id, headers = null) {
    return await this.get(this.GetUri() + `Devices/ById?id=${Id}`, headers);
  }

  async getDeviceTransactions(deviceId) {
    return this.get(this.GetUri() + `devices/transactions/${deviceId}`);
  }
  // TODO: move the rest to CompainService / ExportService this class is dowing enougth ! and please remove axios
  // * transmitter firmware validation
  async validation(data) {
    var queryParameters = {
      params: {
        transmitterFirmwareName: data
      }
    };
    return await Axios.get(
      this.GetUri() + "transmitterFirmwares/validation",
      queryParameters, {
        headers: this.defaultHeaders,
      }
    );
  }

  Export(url, headers = null) {
    return Axios.get(
      url, {
        responseType: "blob",
        headers: headers ?? this.defaultHeaders,
      }
    );
  }

  ExportProcessedFile(url, customfilter, headers = null) {
    return Axios.get(
      url, {
        responseType: "blob",
        headers: {
          ...headers ?? this.defaultHeaders,
          "X-Custom-Filters":customfilter,
          "X-Export-type": "fileProcessing",
      }
    }
    );
  }

  // * send zip file
  async Send(data, uploadPercentage) {
    return await Axios.post(
      this.GetUri() + "transmitterFirmwares",
      data,
      this.GetHeaderWithProgressBarCallBackEvent(uploadPercentage)
    );
  }

  async UploadFile(data, scope, onProgress) {
    return await Axios.post(
      this.GetUri() + `Devices/ToCommonStock/${scope}`,
      data, {
        headers: this.defaultHeaders,
        onUploadProgress: (progressEvent) => {
          const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          onProgress(progress); // Callback with the progress
        }
      }
    );
  }

  // *send compaign
  async SendCompaign(data) {
    return await Axios.post(
      this.GetUri() + "FirmwareCampaigns",
      JSON.stringify(data), {
        headers: this.defaultHeaders,
      }
    );
  }

  // *send compaign
  async Sendparams(devicetype, externalid, params) {

    const data = {
      deviceType: devicetype,
      externalId: externalid,
      parameters: JSON.stringify(params),
    };

    return await Axios.post(this.GetUri() + "Devices", {}, {
      params: data,
      headers: this.defaultHeaders
    });

  }

  // * get list of manufacturers
  async getManufacturers() {
    let manufacturers = [];

    await (
      await Axios.get(this.GetUri() + "Manufacturers", {
        headers: this.defaultHeaders,
      })
    ).data.forEach((element) => {
      manufacturers.push(ManufacturerDTO(element));
    });

    return manufacturers;
  }

  async getCompaignbyId(externalId) {
    let compaign = [];

    let tmp = await (
      await Axios.get(this.GetUri() + "FirmwareCampaigns/" + externalId, {
        headers: this.defaultHeaders,
      })
    ).data;

    compaign.push(CampaignDTO(tmp));

    return compaign;
  }
  // * get device id if transmitter was existed
  //TODO refactor output
  async getTransmitterDevice(identifier) {
    let transmitterDevice = [];
    var queryParameters = {
      params: {
        externalId: identifier
      }
    };
    let tmp = await (
      await Axios.get(this.GetUri() + "TransmitterDevices", queryParameters, {
        headers: this.defaultHeaders,
      })
    ).data;
    transmitterDevice.push(TransmitterDeviceDTO(tmp));
    return transmitterDevice;
  }
  // * get downlink channels
  getDownlinkChannels() {
    // let downlinkChannels = [120, 100, 110, 130, 140, 150];
    let downlinkChannels = [{
        key: 1,
        value: 120,
      },
      {
        key: 2,
        value: 100,
      },
      {
        key: 3,
        value: 110,
      },
      {
        key: 4,
        value: 130,
      },
      {
        key: 5,
        value: 140,
      },
      {
        key: 6,
        value: 150,
      },
    ];
    return downlinkChannels;
  }

  // * get downlink modulations
  getDownlinkModulations() {
    // let downlinkModulations2 = [
    //   "WM2400",
    //   "WM4800",
    //   "HSPEED",
    //   "LD1200",
    //   "LD2400",
    // ];
    let downlinkModulations = [{
        key: 1,
        value: "WM2400"
      },
      {
        key: 2,
        value: "WM4800"
      },
      {
        key: 3,
        value: "HSPEED"
      },
      {
        key: 4,
        value: "LD1200"
      },
      {
        key: 5,
        value: "LD2400"
      },
    ];
    return downlinkModulations;
  }

  // *get target firmware versions - check compatibility on jsonb
  async GetTargetFirmwareVersions(hardware, firmware) {
    let targetFirmwareReponse = [];

    var queryParameters = {
      params: {
        hardwareVersion: hardware,
        currentFirmwareVersion: firmware
      },
    };
    await (
      await Axios.get(
        this.GetUri() + "TransmitterFirmwares/compatibleTransmitterFirmwares",
        queryParameters, {
          headers: this.defaultHeaders,
        }
      )
    ).data.forEach((element) => {
      targetFirmwareReponse.push(TargetFirmwareVersionsResponse(element));
    });
    let targetFirmwareVersions = [];
    targetFirmwareReponse.forEach((e) => {
      targetFirmwareVersions.push({
        firmwareVersion: e.firmwareVersion,
        Id: e.id,
      });
    });
    return targetFirmwareVersions;
  }

  async getDeviceParameters(externalId) {
    let tmp = await (
      await Axios.get(this.GetUri() + "devices/parameters/" + externalId, {
        headers: this.defaultHeaders,
      })
    ).data;

    return tmp;
  }

  GetHeaderWithProgressBarCallBackEvent(uploadPercentage) {
    return {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "multipart/form-data",
        authorization: "Bearer " + this.token,
      },
      onUploadProgress: (progressEvent) => uploadPercentage(progressEvent),
    };
  }
  GetHeaderformData() {
    return {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "multipart/form-data",
        authorization: "Bearer " + this.token,
      },
    };
  }
}